<div style="height: 98dvh; display: flex; justify-content: space-between; flex-direction: column">
  <div>
    <app-additional-action-header [title]="locale.currentTranslation.aboutInsurer"/>
    <div class="base-content-container">
      <div>
        <div>
          <img ngSrc="../../../../assets/img/signal-iduna-logo.svg" height="24" width="129">
        </div>
        <p class="text-body2 text-bold">{{ locale.currentTranslation.aboutInsurerHeadline }}</p>
        <p class="text-body2">{{ locale.currentTranslation.aboutInsurerText1 }}</p>
        <p class="text-body2">{{ locale.currentTranslation.aboutInsurerText2 }}</p>
      </div>
    </div>
  </div>
  <div style="padding: 0 22px 14px 22px">
    <app-footer/>
  </div>
</div>
